import { Modal } from '@myhealth-raccoon/components';
import React, { useCallback, useState } from 'react';
import { useMessageListener, usePostMessage } from 'src/contexts/message';

export function ModalLayout({ children }: React.PropsWithChildren) {
    const [open, setOpen] = useState(true);
    const postMessage = usePostMessage();
    useMessageListener(useCallback((payload) => {
        if (typeof payload === "object" && payload.message === 'myhealth-booking-ui-modal') {
            setOpen(payload.value === "open");
        }
    }, []));

    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);

    const afterClose = useCallback(() => {
        postMessage({ message: "myhealth-booking-ui-modal", value: "close" })
    }, [postMessage]);


    return <Modal
        backdropClassname='bg-transparent'
        size='lg'
        open={open}
        onClose={handleClose}
        hideX
        unstyled
        afterClose={afterClose}
    >
        {children}
    </Modal>
}